



























































import i18n from 'vue-i18n';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';

export default {
    name: 'VerifyEmail',
    components: { CoHeadline, CoText, CoButton, CoInput, CoRoundButton },
    props: {
        email: { type: String, required: true },
        loading: { type: Boolean, default: false },
        expiresIn: { type: Number, required: true },
    },
    data() {
        return { otp: '', invalidOtp: false, cooldown: 0, timer: null as number | null };
    },
    beforeDestroy() {
        if (this.timer) window.clearInterval(this.timer);
    },
    methods: {
        validateOtp(value: string) {
            return Boolean(value?.trim()) && !this.invalidOtp;
        },
        updateOtp(value: string) {
            this.otp = value;
            this.invalidOtp = false;
        },
        // Let CoInput own the visible error and localized hint after a rejected code.
        markInvalid() {
            this.invalidOtp = true;
            this.$nextTick(() => (this.$refs.otpInput as any)?.inputValidation(this.otp));
        },
        // The resend timer limits repeated clicks in this screen; the BFF still enforces its own limit.
        startCooldown(seconds: number) {
            if (this.timer) window.clearInterval(this.timer);
            // The signup session expiry returned by the BFF controls when another code can be requested.
            this.cooldown = Math.max(0, seconds);
            if (!this.cooldown) return;
            this.timer = window.setInterval(() => {
                this.cooldown -= 1;
                if (this.cooldown <= 0 && this.timer) {
                    window.clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
        },
        resend() {
            if (this.cooldown || this.loading) return;
            this.$emit('resend');
        },
    },
};
